<template>
  <div>
    <div class="status">
      {{ $t('message.billOfIndemnity') }} :{{ PKdetail.reparation_sn }} <span>{{ $t('message.status') }} : {{
        PKdetail.status_name }}</span>
    </div>
    <div class="content">
      <div class="table">
        <ol>
          <!--  番号-->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!--  图片-->
          <li>{{ $t("message.pic") }}</li>
          <!--  商品属性-->
          <li>{{ $t("message.commodityAttribute") }}</li>
          <!--  附加服务-->
          <li>{{ $t("message.additionalServices") }}</li>
          <!--  商品数-->
          <li>{{ $t("message.numberOfGoods") }}</li>
          <!--  单价（元）-->
          <li class="flex05">{{ $t("message.priceYuan") }}</li>
          <!-- 问题图片-->
          <li class="flex12">{{ $t("message.problemPic") }}</li>
          <!-- 客户反馈问题诉求（日语）-->
          <li class="flex15">
            {{ $t("message.customerFeedbackProblemRequestJP") }}
          </li>
          <!--业务售后处理意见（日语）-->
          <li class="flex15">
            {{ $t("message.adviceOnAfterSaleHandlingOfBusinessJP") }}
          </li>
          <!-- 产生问题原因-->
          <li class="flex15">{{ $t("message.causeOfTheProblem") }}</li>
          <!--赔款数量）-->
          <li>{{ $t("message.amountOfIndemnity") }}</li>
          <!--商品代赔款-->
          <li>{{ $t("message.indemnitiesForGoods") }}</li>
          <!--国内运费返还-->
          <li>{{ $t("message.returnOfDomesticFreight") }}</li>
          <!--手续费赔款-->
          <li>{{ $t("message.commissionIndemnity") }}</li>
          <!--option赔款-->
          <li>{{ $t("message.optionForCompensation") }}</li>
          <!--合计-->
          <li>{{ $t("message.total") }}</li>

          <!--预计承担金额.-->
          <li>{{ $t("message.estimatedLiability") }}元</li>
        </ol>
        <!-- 列表详情 -->
        <div class="table_detail" v-for="(item, index) in PKdetail.after_sale_detail" :key="index">
          <!-- 订单号分单-->
          <div class="detail_head">
            <!-- 订单 -->
            <div class="order">
              <div>
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank"
                    style="color: #fff;">{{ item.order_sn }}
                  </router-link>
                </p>
                <p>{{ item.user ? item.user.realname : '' }}</p>
              </div>
            </div>
            <!-- 订单汇率 -->
            <div class="item">
              {{ $t("message.orderRate") }}:{{ item.exchange_rate }}円/元
            </div>
            <div class="item">
              {{ $t("message.business") }}:{{ item.y_admin ? item.y_admin.realname : '' }}
            </div>
            <!-- 采购 -->
            <div class="item">
              {{ $t("message.purchase") }}: {{ item.g_admin ? item.g_admin.realname : '' }}
            </div>
            <!-- 配货 -->
            <div class="item">
              {{ $t("message.distribution") }}:{{ item.p_admin ? item.p_admin.realname : '' }}
            </div>
          </div>
          <!-- 列表 -->
          <ul v-for="(items, indexs) in item.list" :key="indexs">
            <!--  番号-->
            <li class="flex05">{{ items.sorting }}</li>
            <!--  图片-->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                  <img :src="items.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </li>
            <!--  商品属性-->
            <li>
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--  附加服务-->
            <li>
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p v-if="opti.num > 0">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price
                        }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 80px">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                      <p v-if="opti.num > 0">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price
                        }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--  商品数-->
            <li>
              <div class="attribute">
                <!-- 购买数 -->
                <p>
                  {{ $t("message.purchaseNumber") }}:{{ items.confirm_num }}
                </p>
                <!-- 发送数 -->
                <p>
                  {{ $t("message.numberOfTransmissions") }}:{{ items.fasong_num }}
                </p>
              </div>
            </li>
            <!--  单价（元）-->
            <li class="flex05">{{ items.confirm_price }}</li>
            <!-- 问题图片-->
            <li class="flex12">
              <div class="imgList">
                <div class="imgs" v-for="(imgs, imgIndex) in items.client_images" :key="imgIndex">
                  <el-image :src="imgs" :preview-src-list="[imgs]" v-if="imgs">
                  </el-image>
                  <!-- <el-popover placement="right" width="300" trigger="hover">
                    <img :src="imgs" alt="" class="el-image" style="width: 280px;">
                    <img :src="imgs" alt="" class="el-image" slot="reference">
                  </el-popover> -->
                </div>
              </div>
            </li>
            <!-- 客户反馈问题诉求（日语）-->
            <li class="flex15">
              {{ items.client_desc }}
            </li>
            <!--业务售后处理意见（日语）-->
            <li class="flex15">
              {{ items.admin_desc }}
            </li>
            <!-- 产生问题原因（内部） -->
            <li class="flex15">
              {{ items.internal_reason }}
            </li>
            <!--赔款数量）-->
            <li>
              {{ items.num }}
            </li>
            <!--商品代赔款-->
            <li>
              <div class="attribute">
                <p>{{ amountRefundName(items.amount_goods_type) }}</p>
                <p>赔付：{{ items.amount_goods_amount }}</p>
              </div>
            </li>
            <!--国内运费返还-->
            <li>
              <div class="attribute">
                <p>{{ amountRefundName(items.amount_freight_type) }}</p>
                <p>赔付：{{ items.amount_freight_amount }}</p>
              </div>
            </li>
            <!--手续费赔款-->
            <li>
              <div class="attribute">
                <p>{{ amountRefundName(items.amount_service_type) }}</p>
                <p>赔付：{{ items.amount_service_amount }}</p>
              </div>
            </li>
            <!--option赔款-->
            <li>
              <div class="attribute">
                <p v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"></p>
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p v-if="opti.refund_num > 0">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.refund_num }} * {{ opti.price
                        }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 80px">
                    <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex">
                      <p v-if="opti.refund_num > 0">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.refund_num }}*{{ opti.price
                        }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--合计-->
            <li>
              <div>
                <p>{{ items.total }}.円</p>
                <p>{{ (items.total / item.exchange_rate).toFixed(2) }}元</p>
              </div>
            </li>

            <!--预计承担金额.-->
            <li>{{ (items.total / item.exchange_rate).toFixed(2) }}元</li>
          </ul>
        </div>
      </div>
      <!-- add -->
      <div class="add">
        <el-button type="success" size="mini" @click="add">{{ $t('message.add') }}</el-button>
      </div>
      <!-- 赔款人 -->
      <div class="indemnity_details">
        <!-- 主责任人 -->
        <div class="responsible_box">
          <!--时间点 -->
          <div class="responsible_person">
            <!-- 提出时间 -->
            <div class="row">
              <div class="label">
                {{ $t('message.forwardTime') }}:
              </div>
              <div class="val">
                {{ PKdetail.created_at }}
              </div>
            </div>
            <!-- 提出人 -->
            <div class="row">
              <div class="label">
                {{ $t('message.peoplePutForward') }}:
              </div>
              <div class="val">{{ PKdetail.created_admin ? PKdetail.created_admin.realname : '' }}</div>
            </div>
            <!-- 确认时间 -->
            <div class="row">
              <div class="label">
                {{ $t('message.acknowledgingTime') }}:
              </div>
              <div class="val">{{ PKdetail.confirm_at }}</div>
            </div>
            <!-- 确认人 -->
            <div class="row">
              <div class="label">
                {{ $t('message.affirmName') }}:
              </div>
              <div class="val"> {{ PKdetail.confirm_admin ? PKdetail.confirm_admin.realname : '' }}</div>
            </div>
            <!-- 赔款上限 -->
            <div class="row">
              <div class="label">
                {{ $t('message.maximumIndemnity') }}:
              </div>
              <div class="val"> </div>
            </div>
            <!-- 具体赔款原因 -->
            <div class="row">
              <div class="label">
                {{ $t('message.reasonForCompensation') }}:
              </div>
              <div class="val">
                <el-input type="textarea" v-model="PKdetail.reason">
                </el-input>
              </div>
            </div>
          </div>
          <!-- 具体责任人 -->
          <div class="responsible_person">
            <!-- 赔款类别 -->
            <div class="row">
              <div class="label">
                {{ $t('message.compensationCategory') }}:
              </div>
              <div class="val">
                <el-select filterable v-model="PKdetail.reparation_reason" size="mini" placeholder="请选择">
                  <el-option v-for="item in reparationReasonList" :label="item" :value="item" :key="item">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 赔款数量:： -->
            <div class="row">
              <div class="label">
                {{ $t('message.amountOfIndemnity') }}:
              </div>
              <div class="val"><el-input v-model="PKdetail.reparation_num" size="mini"
                  @blur="getReparationsByUser"></el-input>
              </div>
            </div>
            <!-- 赔款类型:： -->
            <div class="row">
              <div class="label">
                {{ $t('message.reparationType') }}:
              </div>
              <div class="val">
                <el-select filterable v-model="PKdetail.reparation_type" size="mini" @change="getReparationsByUser"
                  placeholder="请选择">
                  <el-option v-for="item in reparationType" :label="item.value" :value="item.value" :key="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 责任人类别： -->
            <div class="row">
              <div class="label">
                {{ $t('message.categoryOfResponsiblePerson') }}:
              </div>
              <div class="val">
                <!-- 公司员工 -->
                <div class="item">
                  <div class=" radio">
                    <el-radio v-model="liable_type" :label="1" @change="changeRadio">
                      {{ $t('message.companyEmployee') }}
                    </el-radio>
                  </div>
                  <div class="input">
                    <el-select v-model="liable_content" placeholder="请选择" size="small" @change="changeAdmin" filterable>
                      <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 外部物流公司 -->
                <div class="item">
                  <div class=" radio">
                    <el-radio v-model="liable_type" :label="2" @change="changeRadio">
                      {{ $t('message.externalLogisticsCompany') }}
                    </el-radio>
                  </div>
                  <div class="input">
                    <el-select filterable v-model="wuliuName" :placeholder="$t('message.pleaseEnterTheLogisticsNumber')"
                      size="mini" @change="otherResponsibility">
                      <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
                      </el-option>
                    </el-select>
                    <!-- <el-input v-model="wuliuName" size="small" @input="otherResponsibility"></el-input> -->
                  </div>
                </div>
                <!-- 第三方卖家 -->
                <div class="item">
                  <div class=" radio">
                    <el-radio v-model="liable_type" :label="3" @change="changeRadio">
                      {{ $t('message.thirdPartySeller') }}
                    </el-radio>
                  </div>
                  <div class="input">
                    <el-input v-model="thirdParty" size="small" @input="otherResponsibility"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 赔款明细 -->
        <div class="expenses_details">
          <div class="total">
            <div class="item"> 理应赔款金额：<el-input v-model="should_amount"></el-input> 元</div>
            <div class="item">
              实际赔款金额：<el-input v-model="actual_amount"></el-input>元
            </div>
            <div class="item">团队赔款：<el-input v-model="team_amount" type="number" min="0"
                step="0.01"></el-input>元</div>
          </div>
          <div class="table">
            <ol>
              <!-- 赔款明细 -->
              <li>{{ $t('message.compensationDetails') }}</li>
              <!-- 责任人选择 -->
              <li>{{ $t('message.responsiblePersonSelection') }}</li>
              <!-- 责任人角色 -->
              <li>{{ $t('message.responsiblePersonRole') }}</li>
              <!--费用承担 -->
              <li>费用承担</li>
              <!-- 操作 -->
              <li class="flex05">{{ $t('message.operation') }}</li>
            </ol>
            <!-- 关联责任人 -->
            <ul v-for="(item, index) in reparationList" :key="index">
              <!-- 赔款明细 -->
              <li>
                <span v-if="item.type == 2"> {{ $t('message.associatedResponsiblePerson') }} {{ index }}</span>
                <span v-else> 主责任人</span>
              </li>
              <!-- 责任承担人 -->
              <li>
                <el-select v-model="item.main" placeholder="请选择" size="small" @change="changeName($event, index)"
                  filterable v-if="item.type != 3 && item.main != '公司'">
                  <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                  </el-option>
                </el-select>
                <span v-else>{{ item.main == 'company' ? '公司' : item.main }}</span>
              </li>
              <!-- 责任人角色 -->
              <li>{{ item.name }}</li>
              <!-- 承担金额（元） -->
              <li>
                <el-input v-model="item.amount" type="number" onfocus="this.select()"
                  @input="actual_amount_total"></el-input>
              </li>
              <!-- 操作 -->
              <li class="flex05">
                <el-button type="danger" class="dark" size="mini" @click="del(index)" v-if="item.type == 2">
                  {{ $t('message.delete') }}
                </el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation" v-if="PKdetail.status_name != '已确认'">
        <!-- 删除 -->
        <el-button size="small" type="primary" class="dark" @click="deleteReparation" v-if="isAuth(345)">
          {{ $t("message.delete") }}
        </el-button>
        <!-- 修改 -->
        <el-button size="small" type="primary" @click="updateReparation" v-if="isAuth(342)">
          {{ $t("message.edit") }}
        </el-button>
        <!-- 保存 -->
        <!-- <el-button size="small" type="primary">{{ $t("message.save")
        }}</el-button> -->
        <!-- 赔款确认 -->
        <el-button size="small" type="primary" @click="confirmReparation" v-if="isAuth(343)">
          {{ $t("message.confirmationOfClaims") }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { reparationType } from '@/utlis/options'
export default {
  props: {
    PKdetail: { type: Object },
    amountRefundType: { type: Array },
    adminList: { type: Array },
  },
  data() {
    return {
      reparationType,// 赔款类型
      reparation_sn: '',//赔款单号
      liable_type: '', //责任人类别
      liable_content: '',//责任主体内容
      liable_name: '', //责任人名称
      wuliuName: '', //物流填写
      thirdParty: '',//第三方卖家
      reparationList: [], //关联责任人
      responsiblePersonData: {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
      },
      total: 0, //合计
      actual_amount: 0,//理应赔款
      should_amount: 0,//全部实际赔款
      team_amount: 0,//团队赔款
      reparationReasonList: [],//赔款类别选项
      reparation_reason: '',//赔款类别
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
  },
  created() {
    console.log(this.PKdetail);
    this.reparationList = []
    // 数据处理
    this.reparation_sn = this.PKdetail.reparation_sn
    this.liable_type = this.PKdetail.liable_type
    // 处理列表
    this.PKdetail.reparation_amount.forEach((item, index) => {
      if (item.type == 1) {
        this.responsiblePersonData = item
      }
      this.reparationList.push(item)
    })

    this.actual_amount = this.PKdetail.actual_amount
    this.should_amount = this.PKdetail.should_amount
    this.team_amount = this.PKdetail.team_amount == null ? '' : this.PKdetail.team_amount
    this.reparationList.forEach((item, index) => {
      if (item.type != 3 && item.main - 0 > 0) {
        item.main = item.main - 0
        this.changeName(item.main, index)
      }
    })
    // 责任人类别
    if (this.liable_type == 1) {
      this.liable_content = this.PKdetail.liable_content - 0
    } else if (this.liable_type == 2) {
      this.wuliuName = this.PKdetail.liable_content
    } else if (this.liable_type == 3) {
      this.thirdParty = this.PKdetail.liable_content ? this.PKdetail.liable_content : '第三方买家'
    }
    this.reparationReason(this.getReparationReasonLiableContent(), true)
    // this.changeRadio(this.liable_type)

  },
  methods: {
    // 获取赔款类型选项
    reparationReason(liable_content = '', keepSelected = false) {
      const reparation_reason = this.PKdetail.reparation_reason
      if (!keepSelected) {
        this.PKdetail.reparation_reason = ''
      }
      this.$api.capitalApi
        .reparationReason({ liable_content }).then(res => {
          this.reparationReasonList = Array.isArray(res.data) ? res.data : []
          if (keepSelected) {
            this.PKdetail.reparation_reason = reparation_reason
          }
          this.$forceUpdate()
        })
    },
    getReparationReasonLiableContent() {
      if (this.liable_type == 1) return this.liable_content
      if (this.liable_type == 2) return this.wuliuName
      if (this.liable_type == 3) return this.thirdParty
      return ''
    },
    validateReparationReason() {
      if (this.reparationReasonList.length && !this.PKdetail.reparation_reason) {
        this.$message.error('赔款类别未选择')
        return false
      }
      return true
    },
    // 售后-赔款单-修改
    updateReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
        liable_type: this.liable_type,
        liable_content: '',
        afterSaleDetailSet: [],
        reason: this.PKdetail.reason,
        reparationList: JSON.parse(JSON.stringify(this.reparationList)),
        reparation_num: this.PKdetail.reparation_num,
        reparation_type: this.PKdetail.reparation_type,
        reparation_reason: this.PKdetail.reparation_reason,
        should_amount: this.should_amount,
        actual_amount: this.actual_amount,
        team_amount: this.team_amount,
      }
      //  if (datas.reparation_reason == '') return this.$message.error('赔款类别未选择')
      if (datas.reason == '') return this.$message.error('赔款原因未填写')
      // 责任主体内容(责任人ID,物流号,卖家ID)
      if (this.liable_type == 1) {
        datas.liable_content = this.liable_content
      } else if (this.liable_type == 2) {
        datas.liable_content = this.wuliuName
      } else if (this.liable_type == 3) {
        datas.liable_content = this.thirdParty ? this.thirdParty : '第三方买家'
      }
      // 售后详情id 售后详情赔款比例
      this.PKdetail.after_sale_detail.forEach(item => {
        item.list.forEach(items => {
          datas.afterSaleDetailSet.push({
            id: items.id,
            rate: items.rate,
          })
        })
      })
      console.log(this.reparationList);
      if (!this.validateReparationReason()) return
      this.$api.capitalApi.updateReparation(datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.aftersaleDetail()
      })
    },
    //type转换name
    amountRefundName(key) {
      if (this.amountRefundType != false) {
        let item = this.amountRefundType.find((item) => item.key == key);
        return item.value;
      } else {
        return false;
      }
    },
    //新增
    add() {
      this.reparationList.push({
        main: '',
        rate: 1,
        amount: 0,
        type: '2',
        name: '',
        should_amount: 0,
      })
    },
    // 删除
    del(i) {
      this.reparationList.splice(i, 1)
      this.actual_amount_total()
    },
    //责任人类别:选择
    changeRadio(e) {
      if (e == 1) {
        this.getReparationsByUser()
      } else if (e == 2) {
        this.reparationList = []
        this.reparationList.push({
          main: this.wuliuName,
          rate: 1,
          amount: this.should_amount,
          type: '3',
          name: this.wuliuName,
          should_amount: this.should_amount,
        })
      } else if (e == 3) {
        this.reparationList = []
        this.reparationList.push({
          main: this.thirdParty,
          rate: 1,
          amount: this.should_amount,
          type: '3',
          name: this.thirdParty,
          should_amount: this.should_amount,
        })
      }
      this.$forceUpdate()
    },
    //选择主责任人
    changeAdmin(e) {
      let item = this.adminList.find(item => item.id == e)
      this.responsiblePersonData.roleName = item.role[0].name
      this.liable_name = item.realname
      if (this.liable_type == 1) {
        this.responsiblePersonData.main = e
        this.responsiblePersonData.name = this.liable_name
        this.getReparationsByUser()
        this.reparationReason(e)
      }
    },
    // 选择其他责任类别
    otherResponsibility() {
      if (this.liable_type == 2) {
        this.reparationList[0].name = this.wuliuName
        this.reparationList[0].main = this.wuliuName
      } else if (this.liable_type == 3) {
        this.reparationList[0].name = this.thirdParty ? this.thirdParty : '第三方卖家'
        this.reparationList[0].main = this.thirdParty ? this.thirdParty : '第三方卖家'
      }
    },
    // 关联责任人选择
    changeName(e, i) {
      let role = this.adminList.find(item => item.id == e).role
      if (role != false) {
        this.reparationList[i].name = role[0].name
      } else {
        this.reparationList[i].name = ''
      }
      this.$forceUpdate()
    },
    // 根据理应赔款计算金额
    getReparationsByUser() {
      let datas = {
        userName: this.responsiblePersonData.name,
        shouleMoney: this.should_amount,
        type: this.PKdetail.reparation_type,
        numbers: this.PKdetail.reparation_num
      }
      if (datas.userName == '' || datas.type == '' || datas.numbers === '') {
        return false
      }
      this.reparationList = []
      this.$api.capitalApi.getReparationsByUser(datas).then((res) => {
        res.data.peikuan.forEach(item => {
          if (item.name == '公司') {
            this.reparationList.push({
              main: item.name,
              rate: 1,
              amount: item.amount,
              type: '2',
              name: item.name,
              should_amount: 0,
            })
          } else {
            let nameData = this.adminList.find(items => items.realname == item.name)
            this.reparationList.push({
              main: nameData.id,
              rate: 1,
              amount: item.amount,
              type: nameData.realname == datas.userName ? '1' : '2',
              name: nameData.role[0].name,
              should_amount: nameData.realname == datas.userName ? this.actual_amount : 0,
            })
          }
        })
        this.actual_amount_total()
      })
    },
    //删除售后单
    deleteReparation() {
      let datas = {
        reparation_sn: this.PKdetail.reparation_sn,
      };
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.capitalApi.deleteReparation(datas).then((res) => {
            this.$message.success(res.msg)
            this.$parent.aftersaleDetail()
            this.$parent.status = '1'
          });
        })
        .catch(() => { });
    },
    //售后-赔款单-确认
    confirmReparation() {
      let datas = {
        reparation_sn: this.PKdetail.reparation_sn,
      };
      this.$confirm(
        '是否确认赔款确认？',
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.capitalApi.confirmReparation(datas).then((res) => {
            this.$message.success(res.msg)
            this.$parent.aftersaleDetail()
          });
        })
        .catch(() => { });
    },
    //计算合计
    actual_amount_total() {
      this.actual_amount = 0
      this.reparationList.forEach(item => {
        this.actual_amount += item.amount - 0
      })
    },
    getShouldAmount() {
      // 有数量和单价时取“数量×单价”和业务赔款总额中的较大值，否则取业务赔款总额。
      let goodsAmount = 0
      let businessAmount = 0
      let hasGoodsPrice = false
      this.PKdetail.after_sale_detail.forEach(item => {
        item.list.forEach(items => {
          const quantity = Number(items.num)
          const price = Number(items.confirm_price)
          if (items.num !== '' && items.num != null && items.confirm_price !== '' && items.confirm_price != null &&
            Number.isFinite(quantity) && Number.isFinite(price)) {
            hasGoodsPrice = true
            goodsAmount += quantity * price
          }
          const itemTotal = Number(items.amount_goods_amount || 0) + Number(items.amount_freight_amount || 0) +
            Number(items.amount_service_amount || 0) + Number(items.amount_option_amount || 0)
          businessAmount += itemTotal / Number(item.exchange_rate || 1) * Number(items.rate || 0) / 100
        })
      })
      return (hasGoodsPrice ? Math.max(goodsAmount, businessAmount) : businessAmount).toFixed(2)
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

.status {
  margin: 20px 0;
  font-size: 16px;

  span {
    margin-left: 24px;
  }
}

.content {
  padding: 16px 0;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .table_detail {
    .detail_head {
      display: flex;
      font-size: 14px;
      height: 60px;
      background: #545467;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;

      .order {
        display: flex;
        align-items: center;
        padding-left: 16px;
      }

      .item {
        margin-left: 60px;
        line-height: 60px;
      }
    }
  }

  .table {
    font-size: 12px;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
        position: relative;
      }
    }

    .flex12 {
      flex: 1.2;
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }

    .attribute {
      width: 100%;
      text-align: left;
      max-height: 100px;
      overflow: hidden;
      text-align: center;

      .el-button {
        position: absolute;
        top: 5px;
        right: 10px;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .radio {
      flex: 9;
      width: 100%;
      justify-content: flex-start;

      span {
        margin: 0 40px 0 13px;
      }
    }
  }

  .add {
    text-align: right;
    margin-top: 20px;
  }

  .indemnity_details {
    display: flex;
    margin-top: 24px;

    .responsible_box {
      flex: 1;

      .responsible_person {
        border: 2px solid #32323C;

        &:nth-child(1) {
          margin-bottom: 24px;
        }

        .row {
          border-bottom: 1px solid #32323C;

          &:nth-last-child(1) {
            border: 0
          }

          display: flex;

          .label {
            width: 150px;
            border-right: 1px solid #32323C;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 14px 0;
          }

          .val {
            flex: 1;
            padding: 14px 30px;

            .item {
              display: flex;
              line-height: 40px;

              .radio {
                width: 120px;
                margin-right: 10px;

              }

              .input {
                width: 180px;

                /deep/.el-select {
                  width: 100%;
                }

                /deep/.el-input {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }

    .expenses_details {
      flex: 4;
      margin-left: 90px;

      .total {
        display: flex;
        margin-bottom: 10px;

        .item {
          flex: 1;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          line-height: 40px;

          /deep/.el-input {
            width: 100px;
            margin: 0 10px;
          }
        }
      }

      ul {
        li {
          &:nth-child(1) {
            background-color: #fff;
          }
        }
      }

      input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 38px;
        width: 70%;
        padding: 0 10px;
      }
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-textarea__inner {
    width: 90%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}

.operation {
  position: sticky;
  left: 0;
  bottom: 0;
  text-align: right;
  padding: 15px 24px;
  background-color: #edeff4;
  margin-top: 20px;
  border-radius: 0px 0px 8px 8px;
  z-index: 99;
}
</style>
